import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {},
    htmlText: {
      padding: '10px 50px !important',
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      '& p,li': {
        fontWeight: 500
      },
      '@media (max-width: 426px)': {
        padding: '20px 0px 20px 0px !important',
        '& h2': {
          fontSize: '1.2rem'
        },
        '& strong': {
          fontSize: '1rem'
        },
        '& p,li': {
          fontSize: '0.8rem'
        }
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
